// Задержка проверки пересечений после последнего изменения условий робота.
export const KEYWORD_OVERLAPS_CHECK_DELAY_MS = 500;

// Сколько строк пересечений видно в предупреждении. Остальные — «И ещё N».
export const KEYWORD_OVERLAPS_SHOWN_COUNT = 5;
